var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-main',[_c('wzvz_overview',{key:_vm.key,attrs:{"filter":_vm.filter,"acco":_vm.acco}})],1),_c('navBar',{attrs:{"title":"Ares - Main menu","home":true,"type":"main"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }